<div class="cv-modal-component {{modalConfigurationModel.modalCustomClass}}" [ngClass]="{'top-confirm-dialog': modalSize === modalSizeTypes.CONFIRM}">
	<div class="box">
		<div class="modal-title"
			 *ngIf="modalConfigurationModel.title">
			<i *ngIf="modalConfigurationModel.titleIcon"
			   [ngClass]="modalConfigurationModel.titleIcon"></i>
			<label>{{modalConfigurationModel.title}}</label>
		</div>
		<div class="modal-body"
			 [ngClass]="modalSize">

			<ng-template cvDynamicModal></ng-template>

		</div>
		<div class="modal-footer"
			 *ngIf="showActionButtons">
			<div>
				<ng-template ngFor
							 let-actionButton
							 [ngForOf]="currentModalComponentInstance.buttons">
					<button #actionButtons
							class="btn"
							[ngClass]="actionButton.class"
							[disabled]="(actionButton.disabled !== undefined && actionButton.disabled())"
							(click)="actionButton.action()">
						<span *ngIf="!actionButton.loading || !actionButton.loading()">
							<i *ngIf="actionButton.icon"
							   class="fa"
							   [ngClass]="actionButton.icon"></i>
							<span>{{actionButton.text}}</span>
						</span>
						<span *ngIf="(actionButton.loading && actionButton.loading())">
							<div class="loading-wrapper">
								<i class="fas fa-spinner"></i>
							</div>
							<span>{{actionButton.loadingText || 'Loading'}}</span>
						</span>
					</button>
				</ng-template>
			</div>
		</div>
	</div>
</div>
